import { useDisclosure } from "@chakra-ui/react";
import { useEffect, useMemo } from "react";
import { LstBalance } from "../../rest/kairos/types";
import { buildRestakeTokenOptions } from "./buildRestakeTokenOptions";
import { StakeTokenSelectModal } from "./StakeTokenSelectModal";
import { TokenPill } from "./TokenPill";

export interface RestakeSolTokenPickerProps {
  selectedSymbol: string;
  selectedImage: string;
  onSelect: (symbol: string, imageUri?: string) => void;
  solBalance: number;
  jitoSolMint: string;
  jitoSolBalance: number;
  lstBalances: LstBalance[] | null;
  lstLoading?: boolean;
  onOpen?: () => void;
}

export const RestakeSolTokenPicker = ({
  selectedSymbol,
  selectedImage,
  onSelect,
  solBalance,
  jitoSolMint,
  jitoSolBalance,
  lstBalances,
  lstLoading = false,
  onOpen,
}: RestakeSolTokenPickerProps) => {
  const { isOpen, onOpen: openModal, onClose } = useDisclosure();

  const options = useMemo(
    () => buildRestakeTokenOptions(solBalance, jitoSolMint, jitoSolBalance, lstBalances),
    [solBalance, jitoSolMint, jitoSolBalance, lstBalances]
  );

  useEffect(() => {
    if (isOpen) {
      onOpen?.();
    }
  }, [isOpen, onOpen]);

  return (
    <>
      <TokenPill
        image={selectedImage}
        symbol={selectedSymbol}
        showChevron
        onClick={openModal}
      />
      <StakeTokenSelectModal
        isOpen={isOpen}
        onClose={onClose}
        options={options}
        selectedSymbol={selectedSymbol}
        onSelect={(symbol) => {
          const opt = options.find(
            (o) => o.symbol.toLowerCase() === symbol.toLowerCase()
          );
          onSelect(symbol, opt?.imageUri);
        }}
        isLoading={lstLoading}
      />
    </>
  );
};
